import { Box, Backdrop } from '@mui/material';
import { ReactNode } from 'react';
import { makeStyles, withStyles } from '@mui/styles';

const StyledBackdrop = withStyles(() => ({
  root: {
    justifyContent: 'flex-start'
  }
}))(Backdrop);

const useStyles = makeStyles(() => ({
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 1000,
    width: '100%',
    height: '100%'
  }
}));

interface Props {
  showBackdrop: boolean;
  children: ReactNode;
}

const GlobalLoaderOverlay = ({ showBackdrop, children }: Props) => {
  const classes = useStyles();

  if (showBackdrop) {
    return (
      <Box className={classes.container}>
        <StyledBackdrop open={showBackdrop}>{children}</StyledBackdrop>
      </Box>
    );
  }

  return <>{children}</>;
};

export default GlobalLoaderOverlay;
